import { LosseFlexShell } from '@ubo/losse-sjedel'
import type { LosseFlexShellProps, LosseFlexShellType } from '@ubo/losse-sjedel'

// Components
import Members from './Members'

export default function MembersShell({ fields, index }: LosseFlexShellProps) {
  const types: LosseFlexShellType = {
    default: Members
  }

  return <LosseFlexShell types={types} fields={fields} index={index} />
}
